import React from 'react';
import dateFormat from 'dateformat';
import { markupHelpers } from '../../../helpers/index';
import * as Buttons from '../../ui/buttons';
import { getFullMonthYear } from './../../../../../../../helpers/common/date-util';

export const PressItem = props => {
	const {
		title,
		publication,
		url,
		description,
		date,
		buttonHandlers,
		guestMode,
	} = props;
	const convertedTitle = markupHelpers.escapeHtmlHelper(title),
		convertedPublisher = markupHelpers.escapeHtmlHelper(publication),
		convertedDescription = markupHelpers.escapeHtmlHelper(description);

	return (
		<div className="item-achievements press">
			{/*show when not in guestMode*/}
			{!guestMode && (
				<div className="item-display-mode">
					<Buttons.EditButton {...buttonHandlers} />
				</div>
			)}
			{/*/////////*/}
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Title</div>
				<div
					className="col-8 col-lg-9 new-profile-info item-header"
					dangerouslySetInnerHTML={{ __html: convertedTitle }}
				/>
			</div>
			{!publication || publication === 'null' ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Publisher</div>
					<div
						className="col-8 col-lg-9 new-profile-info"
						dangerouslySetInnerHTML={{ __html: convertedPublisher }}
					/>
				</div>
			)}
			{!url || url === 'null' ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Url</div>
					<div className="col-8 col-lg-9 new-profile-info">
						{url.includes('http') ? (
							<a href={url} target="_blank">
								{url}
							</a>
						) : (
							<a href={`http://${url}`} target="_blank">
								{url}
							</a>
						)}
					</div>
				</div>
			)}
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Date</div>
				<div className="col-8 col-lg-9 new-profile-info">
					{ getFullMonthYear( date ) }
				</div>
			</div>
			{!description || description === 'null' ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Description</div>
					<div
						className="col-8 col-lg-9 new-profile-info editor"
						dangerouslySetInnerHTML={{ __html: convertedDescription }}
					/>
				</div>
			)}
		</div>
	);
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/achievements/PressItem.js